/**
 *
 * Plan Selection Modal
 *
 */
import React from 'react';
import {
  ContactLink,
  ContentWrapper,
  Text,
} from './styledComponents';
import Modal from 'components/Modal';
import H1 from 'components/H1';

// See components/PlanSelectionModal for why the upgrade CTA is now "contact us"
// rather than a link to the removed self-serve Memento checkout — and for why
// that contact route is a mailto rather than relying on the Intercom messenger
// alone, with no target="_blank" and the address as its own visible text (a
// mailto opened in a new tab is a blank tab on a device with no mail client).
// This is a genuine custom LITE→UNLIMITED deal, unlike the plan-gated upgrade
// CTAs in ChannelsPage/Forms/MessagingOptionForm, which route through the
// shared `containers/UpgradeCta` (Stripe's plan-upgrade portal, or a rental
// contact-us mailto) instead.
const IntuitiveModal = ({ modalProps, close }) => {
  return(
  <Modal shakeOnOpen close={close} title='Upgrade your plan'>
    <ContentWrapper>
      <H1>
        Ready to Upgrade?
      </H1>
      <Text>
        You've already created the maximum number of channels on your LITE plan.
        You can create another new channel when your plan renews in {modalProps.remainingDays} days,
        or email{' '}
        <ContactLink
          href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd like to upgrade from LITE to UNLIMITED so I can create more channels."
        >
          sales@movebooth.com
        </ContactLink>{' '}
        to upgrade to UNLIMITED.
      </Text>
    </ContentWrapper>
  </Modal>
);}

export default IntuitiveModal;
